import {HttpClient} from "../service/httpClient/HttpClient";

export default function uploadImageToServer(url, token, imageFile) {

    const formData = new FormData();
    formData.append('file', imageFile, imageFile.name.split('.').slice(0, -1).join('.'));
    const serverConnection = new HttpClient()


    return new Promise((resolve, reject) => {

        serverConnection
            .post(
                url + "/compressing/MEDIUM",
                formData,
                serverConnection.prepareUserAccessHeader(token)
            ).then(response => {
            resolve(response)
        }).catch(reason => {
            reject(reason)
        })
    })
}

export function removeImageFromServer(url, token, imageId) {

    const serverConnection = new HttpClient(
        {},
        "https://api.sandooghmn.com/")


    return new Promise((resolve, reject) => {
        serverConnection
            .post(
                url + imageId,
                serverConnection.prepareUserAccessHeader(token)
            ).then(response => {
            resolve(response)
        }).catch(reason => {
            reject(reason)
        })
    })
}